import React, { useEffect, useRef, useState } from 'react';
import MonacoEditor from 'react-monaco-editor';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

const EditableJSONViewerWithToggle = ({ jsonData, onExit, onSave, onCopy, actionmode = 'view'}) => {
   
    const toast = useRef(null);
    
    const [mode, setMode] = useState(actionmode); // 'view' or 'edit'
    const [editorContent, setEditorContent] = useState(JSON.stringify(jsonData?.propValue, null, 2));
    const [isValidJSON, setIsValidJSON] = useState(true);

    useEffect(() => {
        setEditorContent(prev => JSON.stringify(jsonData?.propValue, null, 2) );
        setMode(prev => ({ ...prev, actionmode }));
    }, [jsonData, actionmode]);
    
    const handleEditorChange = (newValue) => {
        setEditorContent(newValue);
        try {
            const parsed = JSON.parse(newValue);
            setIsValidJSON(true);
            onSave?.(parsed);
        } catch {
            setIsValidJSON(false);
           // toast?.current?.show({ severity: 'error', summary: 'Error', detail: 'Invalid JSON. Please fix the syntax before saving.'});    
        }
    };

    const handleCopy = () => {
        //navigator.clipboard.writeText(editorContent);
        onCopy?.(editorContent)
        toast?.current?.show({ severity: 'success', summary: 'Copied', detail: 'JSON copied to clipboard!' });
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="flex justify-content-between align-items-center mb-3">
                <h3 className="m-0 v-none">{mode === 'view' ? 'Property Values Viewer' : 'Property Values Editor'}</h3>
                <div className="flex gap-2">
                    <Button outlined  type='button' icon="pi pi-copy" label="Copy" onClick={handleCopy} className="p-button-sm p-button-info" />
                </div>
            </div>

            <MonacoEditor
                height="400"
                language="json"
                theme="vs-light"
                value={editorContent}
                onChange={handleEditorChange}
                options={{
                    readOnly: mode === 'view',
                    minimap: { enabled: false },
                    formatOnType: true,
                    formatOnPaste: true,
                }}
            />
            {!isValidJSON && (
                <small className="p-error mt-2 block">Invalid JSON syntax.</small>
            )}
        </>
    );
};

export default EditableJSONViewerWithToggle;
